"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dropdown = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

var _utils = require("../../utils");

var _usePortal2 = require("../../utils/usePortal");

var _Box = require("../Box");

var _reactFocusOn = require("react-focus-on");

var _excluded = ["placement", "visible", "keepInDOM", "children", "offset", "dropdown", "openDropdownByClick"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * A `Dropdown` is a small modal-type element which is anchored, and can be
 * positioned relative to, another element and designed to be transitioned in on hover or on click.
 */
var Dropdown = function Dropdown(_ref) {
  var _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? "top" : _ref$placement,
      _ref$visible = _ref.visible,
      _visible = _ref$visible === void 0 ? false : _ref$visible,
      keepInDOM = _ref.keepInDOM,
      children = _ref.children,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? 10 : _ref$offset,
      dropdown = _ref.dropdown,
      openDropdownByClick = _ref.openDropdownByClick,
      rest = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1]; // If prop updates/set initial visibility.


  (0, _react.useEffect)(function () {
    setVisible(_visible);
  }, [_visible]);
  var timeoutRef = (0, _react.useRef)(null);

  var onVisible = function onVisible() {
    timeoutRef.current && clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(function () {
      setVisible(true);
    }, 50);
  };

  var onHide = function onHide() {
    timeoutRef.current && clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(function () {
      if (activeRef.current) return;
      setVisible(false);
    }, 150);
  };

  var onToggleVisibility = function onToggleVisibility() {
    if (visible) {
      return onHide();
    }

    onVisible();
  };

  var _usePosition = (0, _utils.usePosition)({
    position: placement,
    offset: 0,
    active: visible
  }),
      anchorRef = _usePosition.anchorRef,
      panelRef = _usePosition.tooltipRef,
      isFlipped = _usePosition.state.isFlipped;

  (0, _react.useEffect)(function () {
    var handleKeyDown = function handleKeyDown(event) {
      if (event.key === "Escape") {
        onHide();
      }
    }; // Close dropdown when focus leaves element


    var handleKeyUp = function handleKeyUp(event) {
      if (!panelRef.current) return;

      if (event.key === "Tab" && !(panelRef.current === document.activeElement || panelRef.current.contains(document.activeElement))) {
        onHide();
      }
    };

    var handleClick = function handleClick(event) {
      if (!panelRef.current || !openDropdownByClick) return;
      var target = event.target;
      var tagName = target.tagName.toLowerCase();
      var isClosableElement = tagName === "a";
      var element = target; // Find parent link element

      if (!isClosableElement) {
        element = target.closest("a");
        isClosableElement = !!element;
      }

      if (isClosableElement && element && panelRef.current.contains(element)) {
        onHide();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    document.addEventListener("keyup", handleKeyUp);
    document.addEventListener("click", handleClick);
    return function () {
      document.removeEventListener("keydown", handleKeyDown);
      document.removeEventListener("keyup", handleKeyUp);
      document.removeEventListener("click", handleClick);
    };
  }, [panelRef, openDropdownByClick]);
  var activeRef = (0, _react.useRef)(false);

  var handleMouseEnter = function handleMouseEnter() {
    activeRef.current = true;
  };

  var handleMouseLeave = function handleMouseLeave() {
    activeRef.current = false;
    onHide();
  };

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      transition = _useState4[0],
      setTransition = _useState4[1]; // Wait for next tick so that animation runs


  (0, _react.useEffect)(function () {
    setTimeout(function () {
      setTransition(visible);
    }, 0);
  }, [visible]);
  var translation = (0, _react.useMemo)(function () {
    switch (placement) {
      case "top-start":
      case "top":
      case "top-end":
        return "translateY(10px)";

      case "bottom-start":
      case "bottom":
      case "bottom-end":
        return "translateY(-10px)";

      case "left-start":
      case "left":
      case "left-end":
        return "translateX(10px)";

      case "right-start":
      case "right":
      case "right-end":
        return "translateX(-10px)";
    }
  }, [placement]); // Fills offset gap between anchor and panel to prevent mouseout

  var padding = (0, _react.useMemo)(function () {
    switch (placement) {
      case "top-start":
      case "top":
      case "top-end":
        return _defineProperty({}, isFlipped ? "pt" : "pb", offset);

      case "bottom-start":
      case "bottom":
      case "bottom-end":
        return _defineProperty({}, isFlipped ? "pb" : "pt", offset);

      case "left-start":
      case "left":
      case "left-end":
        return _defineProperty({}, isFlipped ? "pl" : "pr", offset);

      case "right-start":
      case "right":
      case "right-end":
        return _defineProperty({}, isFlipped ? "pr" : "pl", offset);
    }
  }, [placement, isFlipped, offset]);

  var anchorProps = _objectSpread({
    "aria-expanded": visible,
    "aria-haspopup": true
  }, openDropdownByClick ? {
    onClick: onToggleVisibility
  } : {
    onMouseEnter: onVisible,
    onMouseLeave: onHide,
    onClick: onVisible
  });

  var _usePortal = (0, _usePortal2.usePortal)(),
      createPortal = _usePortal.createPortal;

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children({
    anchorRef: anchorRef,
    anchorProps: anchorProps,
    onVisible: onVisible,
    onHide: onHide,
    setVisible: setVisible,
    visible: visible
  }), (visible || keepInDOM) && createPortal( /*#__PURE__*/_react.default.createElement(Container, _extends({
    "aria-label": "Press escape to close",
    tabIndex: 0,
    ref: panelRef,
    zIndex: 1,
    display: "inline-block",
    placement: placement,
    style: _objectSpread({}, keepInDOM ? {
      visibility: visible ? "visible" : "hidden"
    } : {})
  }, openDropdownByClick ? {} : {
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, padding, rest), /*#__PURE__*/_react.default.createElement(Panel, {
    bg: "white100",
    border: "1px solid",
    borderColor: "black10",
    style: transition ? // In
    {
      opacity: 1,
      transform: "translate(0)"
    } : // Out
    {
      opacity: 0,
      transform: translation
    }
  }, /*#__PURE__*/_react.default.createElement(_reactFocusOn.FocusOn, {
    noIsolation: true,
    enabled: visible,
    onClickOutside: onHide
  }, typeof dropdown === "function" ? dropdown({
    onVisible: onVisible,
    onHide: onHide,
    setVisible: setVisible,
    visible: visible
  }) : dropdown)))));
};

exports.Dropdown = Dropdown;
var Container = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Dropdown__Container",
  componentId: "je1xqj-0"
})(["position:fixed;text-align:left;outline:0;"]);
var Panel = (0, _styledComponents.default)(_Box.Box).withConfig({
  displayName: "Dropdown__Panel",
  componentId: "je1xqj-1"
})(["transition:opacity 250ms ease-out,transform 250ms ease-out;box-shadow:", ";"], _helpers.FLAT_SHADOW);
//# sourceMappingURL=Dropdown.js.map